import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Azioni, IAzioniLng, ModelNumStr } from '../../models/-index';

@Injectable()
export class AzioniService extends CrudGenericsService<Azioni, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Azioni`);
    this.base = `${env.apiUrl}/api/Azioni/`;
  }

  // web
  GetAll_AzioniLng(): Observable<IAzioniLng[]> {
    const url = this.base + 'GetAll_AzioniLng';
    return this.http.get<IAzioniLng[]>(`${url}`);
  }
  // web
  Get4Select_Codici(): Observable<ModelNumStr[]> {
    const url = this.base + 'Get4Select_Codici';
    return this.http.get<ModelNumStr[]>(`${url}`);
  }
}
